import React, { useEffect, useState } from 'react';
import { MDBContainer, MDBRow, MDBCol } from "mdb-react-ui-kit";
import financialimpact from '../img/medicalbillingservices/DenailServices/financialimg.jpg';
import Eligibility from '../img/medicalbillingservices/DenailServices/types-of-claims/Eligibility-and-Authorization-Denials.jpg';
import coding from '../img/medicalbillingservices/DenailServices/types-of-claims/Coding-and-Documentation-Denials.jpg';
import payerspecific from '../img/medicalbillingservices/DenailServices/types-of-claims/Payer-Specific-Policy Denials.jpg';
import timelyfil from '../img/medicalbillingservices/DenailServices/types-of-claims/Timely-Filing-and-Submission-Errors.jpg';
import VisibilityIcon from '../img/medicalbillingservices/DenailServices/benifits/ClearVisibility-Denial-Performance.jpg';
import ComplianceIcon from '../img/medicalbillingservices/DenailServices/benifits/Compliance-Focused-Denial-Management.jpg';
import CashFlowIcon from '../img/medicalbillingservices/DenailServices/benifits/Faster-Reimbursements-Improved-Cash Flow.jpg';
import ReducedDenialIcon from '../img/medicalbillingservices/DenailServices/benifits/Reduced-Denial-Rates-Revenue-Leakage.jpg';
import DenialManagement from '../img/medicalbillingservices/DenailServices/whyto-choose/Focused-Expertise-U.S.-Denial-Management.jpg';
import Structrd from '../img/medicalbillingservices/DenailServices/whyto-choose/Structured-Accountable-Workflows.jpg';
import Transprency from '../img/medicalbillingservices/DenailServices/whyto-choose/Transparency-Through-Reporting-Oversight.jpg';
import scallable from '../img/medicalbillingservices/DenailServices/whyto-choose/Scalable-Support-Growing-Practices.jpg';
import customer from '../img/medicalbillingservices/DenailServices/customer-care.jpg';


import DenailInfo from '../../src/pages/Services_Denail_info';
import RCMcy from '../img/Denail_Management.jpg';
import DownContact from '../components/downcontact';

import { Helmet } from 'react-helmet';
import Banner from '../components/img_banner';
import "../css/servicesfont.css";

const MedicalbillingDesc = () => {
  const [BannerTitle, setBannerTitle] = useState({
    title: "Denial Management Services",
    // subtitle: "Simplify Credential Upkeep for Seamless payer Interactions with Hassle-free Maintenance.",
    img: `url(${RCMcy})`,
    alt: " Medical denial management team analyzing claim data and charts"
  });

  // Set DownContact Heading
  const [DownContactTitle, setDownContactTitle] = useState({ title: "Turn Denials Into Dollars — Expert Denial Management That Maximizes Your Revenue." });

  return (

    <MDBContainer fluid className="p-0 bg-light">
      <Helmet>
        <title>Denial Management Services in the USA | AcerHealth</title>
        <link rel="canonical" href="https://acerhealth.com/services/denial-management-services" />
        <meta name="description" content="Reduce claim denials and recover lost revenue with denial management services built for U.S. healthcare practices. HIPAA-compliant. Transparent reporting." />
        <meta name="keywords" content="Denial Management Services in the USA " />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                "@id": "https://acerhealth.com/#organization",
                "name": "AcerHealth",
                "url": "https://acerhealth.com",
                "logo":"%PUBLIC_URL%/favicon.png"
              },
              {
                "@type": "WebPage",
                "@id": "https://acerhealth.com/services/denial-management-services#webpage",
                "url": "https://acerhealth.com/services/denial-management-services",
                "name": "Denial Management Services in the USA | AcerHealth",
                "description": "Reduce claim denials and recover lost revenue with denial management services built for U.S. healthcare practices. HIPAA-compliant. Transparent reporting.",
                "publisher": {
                  "@id": "https://acerhealth.com/#organization"
                }
              },
              {
                "@type": "Service",
                "@id": "https://acerhealth.com/services/denial-management-services#service",
                "name": "Denial Management Services in the USA",
                "url": "https://acerhealth.com/services/denial-management-services",
                "description": "HIPAA-compliant denial management services designed for U.S. healthcare practices to reduce claim denials, recover revenue, and improve reimbursement outcomes.",
                "provider": {
                  "@id": "https://acerhealth.com/#organization"
                },
                "areaServed": {
                  "@type": "Country",
                  "name": "United States"
                },
                "serviceType": "Healthcare Denial Management",
                "audience": {
                  "@type": "Audience",
                  "audienceType": "U.S. Healthcare Practices"
                }
              },
              {
                "@type": "FAQPage",
                "@id": "https://acerhealth.com/services/denial-management-services#faq",
                "mainEntity": [
                  {
                    "@type": "Question",
                    "name": "Who should use denial management services in the USA?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Denial management services are ideal for U.S. healthcare practices experiencing frequent claim denials, delayed reimbursements, or revenue leakage due to complex payer rules and documentation requirements."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Does AcerHealth provide denial management services only for U.S. practices?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes. AcerHealth’s denial management services are designed exclusively for U.S. healthcare practices and aligned with U.S. payer guidelines, reimbursement models, and regulatory standards."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "How do denial management services help recover lost revenue?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Denial management services help recover revenue by identifying root causes of denials, correcting errors, managing appeals, and ensuring timely follow-ups with payers to secure rightful reimbursements."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Are AcerHealth’s denial management services HIPAA compliant?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes. AcerHealth follows HIPAA-compliant processes and data security standards to protect patient information and billing data throughout the denial management lifecycle."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "How quickly can denial management services be implemented?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Implementation timelines depend on practice size and denial volume, but AcerHealth follows a structured onboarding process to ensure a smooth and efficient transition with minimal disruption."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Will I have visibility into denial resolution and performance?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes. AcerHealth provides transparent reporting on denial trends, resolution rates, and recovery performance so practices can monitor outcomes without managing day-to-day denial activities."
                    }
                  }
                ]
              }
            ]
          })}
        </script>
      </Helmet>
      <Banner BannerTitle={BannerTitle} />


      <DenailInfo />
      <div className="mx-4 mx-md-5 mx-xl-6">
        <div className="row">
          <div className="col-lg-12 mb-5">
            <section className="py-5 overflow-hidden" style={{ backgroundColor: '#ffffff' }}>
              <div className="container-fluid px-5 ">
                <div className="row g-3 align-items-center">

                  {/* LEFT SIDE: Content */}
                  <div className="col-lg-6 order-2 order-lg-1">
                    {/* 1. Changed 'pe-lg-1' to 'ps-lg-5' to push text from the left toward the right.
          2. Added a custom margin-left for finer control if needed.
      */}
                    <div style={{ paddingLeft: '60px' }}>

                      <h2 className="main-title">
                        The Financial Impact of <span className="text-gradient">Claim Denials on U.S. Healthcare Practices</span>
                      </h2>

                      <p className="para-desc mb-3" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify' }}>
                        Claim denials directly impact the financial performance of U.S. healthcare practices by delaying payments, increasing rework, and diverting staff time
                        away from patient-focused activities. With complex payer policies, frequent regulatory updates, and strict submission requirements,
                        even minor billing inaccuracies can result in denied or underpaid claims.
                      </p>

                      <p className="para-desc mb-0" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify' }}>
                        Unresolved denials often lead to permanent revenue loss, reduced cash flow predictability, and higher operational costs as internal teams struggle to manage follow-ups
                        and appeals alongside daily billing responsibilities. Without a structured denial management process, practices risk accumulating backlogs, missing appeal deadlines, and experiencing ongoing reimbursement instability.
                      </p>

                    </div>
                  </div>

                  {/* RIGHT SIDE: Visual Media (No changes made here) */}
                  <div className="col-lg-5 order-1 order-lg-2 mb-5 mb-lg-0">
                    <div className="position-relative">
                      <div style={{
                        width: '80%',
                        maxWidth: '500px',
                        height: '650px',
                        margin: '0 auto',
                        borderRadius: '18px',
                        overflow: 'hidden',
                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                      }}>
                        <img
                          src={financialimpact}
                          alt="Healthcare financial support illustration"
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <style>{`
      .main-title {
      font-size: 2.4rem;
      font-weight: 800;
      color: #0f172a;
      letter-spacing: -1px;
    }
         .text-gradient {
      background: linear-gradient(135deg, #4361ee, #7209b7);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

   `}</style>
            </section>
          </div>

          {/* Changed mx-4 mx-md-5 mx-xl-6 to mx-auto to center a wider container */}
          <section className="py-5 mx-auto" style={{ backgroundColor: '#ffffff', fontFamily: 'sans-serif', overflow: 'hidden', width: '95%' }}>
            <style>{`
    .how-it-works {
      background: #ffffff;
    }

    .how-wrapper {
      /* Increased from 1100px to 1400px for a wider feel */
      max-width: 1400px; 
      margin: 0 auto;
      position: relative;
      padding: 60px 20px;
    }

    /* Center dotted line */
    .how-wrapper::before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 50%;
      width: 2px;
      background: repeating-linear-gradient(
        to bottom,
        #e5e7eb 0,
        #e5e7eb 6px,
        transparent 6px,
        transparent 14px
      );
      transform: translateX(-50%);
    }

    .how-step {
      display: grid;
      /* Adjusted column widths to give text more space */
      grid-template-columns: 1fr 150px 1fr; 
      align-items: center;
      margin-bottom: 80px;
      position: relative;
    }

    .how-step:last-child {
      margin-bottom: 0;
    }

    .step-left {
      text-align: right;
      padding-right: 60px; /* Increased padding for wider layout */
    }

    .step-right {
      text-align: left;
      padding-left: 60px; /* Increased padding for wider layout */
    }

    .step-center {
      display: flex;
      justify-content: center;
      position: relative;
    }

    .step-icon {
      width: 90px;
      height: 90px;
      border-radius: 50%;
      background: #b8c1e6;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 32px;
      box-shadow: 0 20px 40px rgba(61, 55, 99, 0.25);
      z-index: 2;
      transform: translateY(-75px);
    }

    .step-number {
      font-size: 14px;
      font-weight: 800;
      letter-spacing: 2px;
      color: #55419e;
      margin-bottom: 10px;
    }

    .step-title {
      font-size: 28px;
      font-weight: 900;
      color: #6051d3;
      margin-bottom: 12px;
    }

   .how-step {
  display: grid;
  grid-template-columns: 1fr 150px 1fr;
  align-items: center; /* Keeps everything centered vertically */
  margin-bottom: 30px;
}

.step-left {
  text-align: right;
  padding-right: 60px;
}

.step-right {
  text-align: left;
  padding-left: 60px;
}

.step-desc {
  font-size: 17px;
  color: #5b6777;
  line-height: 1.7; /* Increased slightly for better breathing room */
  max-width: 500px; /* Prevents the text from stretching too far on wide screens */
  display: inline-block; /* Allows margins to work on the block */

}

.step-left .step-desc {
  margin-left: auto; /* Aligns the desc block to the right edge of the left column */
}

    @media (max-width: 991px) {
      .how-wrapper::before {
        left: 40px;
      }

      .how-step {
        grid-template-columns: 80px 1fr;
      }

      .step-left,
      .step-right {
        grid-column: 2;
        text-align: left;
        padding: 0 0 0 20px;
      }

      .step-center {
        grid-row: 2;
        justify-content: flex-start;
      }
    }
  `}</style>

            <div className="text-center mb-0">
              <h2 className="main-title">
                How AcerHealth’s <span className="text-gradient">Denial Management Services Work </span>
              </h2>
              {/* Increased maxWidth of header text to match new section width */}
              <p style={{ maxWidth: 1200, margin: '15px auto', fontSize: 20, color: '#64748b', fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify' }}>
                AcerHealth follows a structured denial management process designed to help U.S. healthcare practices
                resolve denied claims efficiently while preventing recurring revenue loss. Our approach emphasizes operational
                continuity, payer-specific accuracy, and ongoing performance visibility—without adding administrative strain to internal teams.
              </p>
            </div>

            <div className="how-wrapper">
              {/* STEP 01 */}
              <div className="how-step">
                <div className="step-left">
                  <h3 className="step-title">Onboarding & Intake</h3>
                  <p className="step-desc">
                    We begin with a structured onboarding process to understand your practice’s billing environment, payer mix, denial patterns,
                    and existing workflows. This intake phase ensures secure access, alignment with U.S. payer requirements, and a smooth
                    transition of denial management responsibilities without disrupting ongoing billing operations.
                  </p>
                </div>
                <div className="step-center">
                  <div className="step-icon">📋</div>
                </div>
                <div></div>
              </div>

              {/* STEP 02 */}
              <div className="how-step">
                <div></div>
                <div className="step-center">
                  <div className="step-icon">🔍</div>
                </div>
                <div className="step-right">
                  <h3 className="step-title">Denial Analysis</h3>
                  <p className="step-desc">
                    Each denied claim is reviewed to identify the exact root cause, including eligibility issues, authorization gaps,
                    coding discrepancies, documentation deficiencies, or payer-specific policy violations. This detailed analysis
                    enables accurate categorization of denials and establishes a clear resolution path aligned with U.S. reimbursement rules.
                  </p>
                </div>
              </div>

              {/* STEP 03 */}
              <div className="how-step">
                <div className="step-left">

                  <h3 className="step-title">Resolution & Appeals</h3>
                  <p className="step-desc">
                    AcerHealth manages corrective actions, claim resubmissions, and formal appeals based on payer guidelines and timely filing requirements.
                    Our teams follow defined appeal workflows to maximize recovery opportunities while minimizing delays, helping practices accelerate
                    reimbursements and reduce outstanding accounts receivable.
                  </p>
                </div>
                <div className="step-center">
                  <div className="step-icon">📨</div>
                </div>
                <div></div>
              </div>

              {/* STEP 04 */}
              <div className="how-step">
                <div></div>
                <div className="step-center">
                  <div className="step-icon">📊</div>
                </div>
                <div className="step-right">
                  <h3 className="step-title">Prevention & Reporting</h3>
                  <p className="step-desc">
                    Beyond resolution, AcerHealth focuses on preventing repeat denials through trend analysis, process improvements, and actionable insights.
                    Practices receive regular reports covering denial trends, recovery performance, and resolution timelines—providing transparency and
                    control while supporting long-term denial rate reduction.
                  </p>
                </div>
              </div>
            </div>
          </section>

<style>{`
  .cta-wrapper {
    max-width: 1300px;
    margin: 20px auto;
    padding: 0 20px;
  }

  .cta-card {
    display: flex;
    align-items: stretch;
    background: linear-gradient(135deg, #1e3a8a 0%, #6258cf 100%);
    border-radius: 40px;
    overflow: hidden;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  /* Left Side: Image Container */
  .cta-image-side {
    flex: 1;
    min-height: 350px;
    position: relative;
    background: #f0f4ff; /* Placeholder color */
  }

  .cta-image-side img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    mix-blend-mode: multiply; /* Optional: blends image with a tint */
    opacity: 0.9;
  }

  /* Right Side: Content Container */
  .cta-content-side {
    flex: 1.2;
    padding: 0 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #ffffff;
  }

  .cta-tagline {
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: #a5b4fc;
    margin-bottom: 20px;
  }

  .cta-title {
    font-size: clamp(2rem, 4vw, 2.8rem);
    font-weight: 800;
    line-height: 1.1;
    margin-bottom: 24px;
    letter-spacing: -1px;
  }

  .cta-description {
    font-size: 18px;
    line-height: 1.6;
    color: #e0e7ff;
    margin-bottom: 35px;
    max-width: 500px;
  }

  .cta-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    color: #4338ca;
    padding: 16px 32px;
    border-radius: 14px;
    font-weight: 700;
    font-size: 17px;
    text-decoration: none;
    transition: all 0.3s ease;
    width: fit-content;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }

  .cta-button:hover {
    background: #f8fafc;
    transform: translateY(-3px);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.2);
  }

  /* Mobile Responsive */
  @media (max-width: 991px) {
    .cta-card {
      flex-direction: column;
    }
    .cta-image-side {
      height: 300px;
      min-height: 300px;
    }
    .cta-content-side {
      padding: 40px 30px;
      text-align: center;
      align-items: center;
    }
  }
`}</style>

<div className="cta-wrapper">
  <div className="cta-card">
    {/* LEFT IMAGE */}
    <div className="cta-image-side">
      <img 
        src={customer} 
        alt="AcerHealth expert discussing denial management strategy" 
      />
    </div>

    {/* RIGHT CONTENT */}
    <div className="cta-content-side">

      <h2 className="cta-title">
        Ready to reduce claim denials and protect your revenue?
      </h2>
      <p className="cta-description">
       Talk to an AcerHealth denial management expert about services built for U.S. healthcare practices.
      </p>
      <a href="/contact-us" className="cta-button">
        Consult an Expert Today
      </a>
    </div>
  </div>
</div>





          <section className="py-5 px-4 mt-4" style={{ backgroundColor: '#ffffff', fontFamily: 'sans-serif' }}>
            <style>{`
    .stratos-container {
      display: flex;
      flex-wrap: wrap;
      gap: 50px;
      position: relative;
    }

    .stratos-sidebar {
      flex: 1;
      min-width: 300px;
      position: sticky;
      top: 100px;
      height: fit-content;
    }

    .stratos-content {
      flex: 2;
      min-width: 300px;
      display: flex;
      flex-direction: column;
      gap: 30px;
    }

    .stratos-card {
      background: #f8f9ff;
      border-radius: 40px;
      padding: 50px;
      display: flex;
      align-items: center;
      gap: 40px;
      transition: all 0.6s cubic-bezier(0.2, 1, 0.3, 1);
      border: 1px solid transparent;
      position: relative;
      overflow: hidden;
    }

    .stratos-card:hover {
      background: #ffffff;
      border-color: #6c5ce7;
      transform: scale(1.02);
      box-shadow: 0 40px 100px rgba(108, 92, 231, 0.1);
    }

    .stratos-icon-box {
      flex-shrink: 0;
      width: 120px;
      height: 120px;
      background: #ffffff;
      border-radius: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 15px 35px rgba(0,0,0,0.05);
      transition: all 0.5s ease;
    }

    .stratos-card:hover .stratos-icon-box {
      background: #6c5ce7;
      border-radius: 50%;
      transform: rotate(15deg);
    }

    .stratos-icon-box img {
      width: 100px;
      height: 100px;
      object-fit: contain;
      transition: all 0.5s ease;
    }

    .stratos-card:hover .stratos-icon-box img {
      filter: brightness(0) invert(1);
    }

    .stratos-info {
      flex-grow: 1;
    }

    .stratos-number {
      font-family: 'Alegreya Sans', sans-serif;
      font-weight: 800;
      color: #6c5ce7;
      font-size: 1.1rem;
      display: block;
      margin-bottom: 10px;
      opacity: 0.6;
    }

    .stratos-title {
      font-size: 1.8rem;
      font-weight: 900;
      color: #1a1a1a;
      margin-bottom: 15px;
      letter-spacing: -1px;
    }

    .stratos-desc {
      font-size: 18px;
      line-height: 1.7;
      color: #636e72;
      font-family: 'Alegreya Sans', sans-serif;
      font-weight: 500;
      margin: 0;
    }

    /* Decorative Vertical Line */
    .stratos-line {
      position: absolute;
      left: 0;
      top: 0;
      width: 8px;
      height: 0;
      background: #6c5ce7;
      transition: height 0.5s ease;
    }

    .stratos-card:hover .stratos-line {
      height: 100%;
    }

    @media (max-width: 991px) {
      .stratos-sidebar { position: static; text-align: center; }
      .stratos-card { flex-direction: column; text-align: center; padding: 40px 25px; }
    }
  `}</style>


            <div className="stratos-container  ">
              {/* LEFT SIDEBAR - Stays fixed while scrolling */}
              <div className="stratos-sidebar">
                <h2 className="main-title mb-4" style={{ fontSize: '2.6rem', fontWeight: '800', letterSpacing: '-1.5px' }}>
                  Types of  <span className="text-gradient"> Claim Denials We Manage</span>
                </h2>

                {/* NEW CONTENT AREA AFTER H2 */}
                <p className="para-desc mx-auto mb-0" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify' }}>
                  AcerHealth supports U.S. healthcare practices by managing a wide range of claim denials that commonly disrupt reimbursement and cash flow.
                  Our denial management services are designed to address both high-frequency errors and complex payer-driven denials across Medicare,
                  Medicaid, and commercial insurance plans.
                </p>
              </div>

              {/* RIGHT CONTENT - The Cards */}
              <div className="stratos-content">

                {/* Card 1 */}
                <div className="stratos-card">
                  <div className="stratos-line"></div>
                  <div className="stratos-icon-box">
                    <img src={Eligibility} alt="Insurance eligibility and prior authorization verification for medical claims to prevent denials and ensure accurate healthcare billing" />
                  </div>
                  <div className="stratos-info">
                    <h3 className="stratos-title">Eligibility & Authorization Denials</h3>
                    <p className="stratos-desc">
                      We manage denials related to inactive coverage, eligibility mismatches, and missing or incorrect prior authorizations.
                      These denials are reviewed against payer-specific requirements to ensure accurate correction and timely resolution.
                    </p>
                  </div>
                </div>

                {/* Card 2 */}
                <div className="stratos-card">
                  <div className="stratos-line"></div>
                  <div className="stratos-icon-box">
                    <img src={coding} alt="Medical coding and documentation mismatch between patient records and CPT ICD codes leading to claim denials in healthcare billing" />
                  </div>
                  <div className="stratos-info">
                    <h3 className="stratos-title">Coding & Documentation Denials</h3>
                    <p className="stratos-desc">
                      Denials caused by coding inaccuracies, modifier issues, or insufficient clinical documentation are carefully analyzed and corrected.
                      Our teams align coding and documentation with payer guidelines to improve claim acceptance and reduce rework.
                    </p>
                  </div>
                </div>

                {/* Card 3 */}
                <div className="stratos-card">
                  <div className="stratos-line"></div>
                  <div className="stratos-icon-box">
                    <img src={timelyfil} alt=" Calendar and clock with warning symbol representing timely filing and submission errors that cause medical claim denials in healthcare billing" />
                  </div>
                  <div className="stratos-info">
                    <h3 className="stratos-title">Timely Filing & Submission Errors</h3>
                    <p className="stratos-desc">
                      Missed deadlines and submission errors can lead to permanent revenue loss. AcerHealth tracks timely filing limits and
                      submission requirements to help practices recover eligible claims and prevent avoidable write-offs
                    </p>
                  </div>
                </div>

                {/* Card 4 */}
                <div className="stratos-card">
                  <div className="stratos-line"></div>
                  <div className="stratos-icon-box">
                    <img src={payerspecific} alt="Insurance card and payer building with alert symbol representing payer-specific policy denials and coverage verification issues in healthcare billing" />
                  </div>
                  <div className="stratos-info">
                    <h3 className="stratos-title">Payer-Specific Policy Denials</h3>
                    <p className="stratos-desc">
                      Each payer follows unique billing rules and denial criteria. We manage denials tied to payer-specific policies,
                      coverage limitations, and reimbursement conditions through targeted follow-ups and corrective actions.
                    </p>
                  </div>
                </div>

              </div>
            </div>

          </section>

      <section className="py-5 px-4 mt-4" style={{ backgroundColor: '#ffffff', fontFamily: '"Inter", sans-serif' }}>
      <style>{`
        .bento-container {
          max-width: 1600px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .bento-grid {
          display: grid;
          grid-template-columns: repeat(12, 1fr);
          gap: 24px;
        }

        .bento-card {
          background: #ffffff;
          border-radius: 32px;
          padding: 40px;
          border: 1px solid #eef0f7;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
          overflow: hidden;
        }

        .bento-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 22px 45px rgba(108, 92, 231, 0.12);
          border-color: #6c5ce7;
        }

        .bento-large { grid-column: span 7; }
        .bento-medium { grid-column: span 5; }

        .image-wrapper {
          width: 100%;
          height: 240px;
          background: linear-gradient(135deg, #f8f9ff 0%, #f1f0ff 100%);
          border-radius: 20px;
          margin-bottom: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .bento-card img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          transition: transform 0.4s ease;
        }

        .bento-card:hover img {
          transform: scale(1.05) rotate(-1deg);
        }

        .text-content {
          position: relative;
          z-index: 2;
        }

        .bento-tag {
          display: inline-block;
          padding: 6px 14px;
          background: rgba(108, 92, 231, 0.08);
          color: #6c5ce7;
          border-radius: 100px;
          font-size: 12px;
          font-weight: 700;
          text-transform: uppercase;
          margin-bottom: 15px;
          letter-spacing: 1px;
        }

        .bento-title {
          font-size: 1.75rem;
          font-weight: 800;
          color: #111827;
          margin-bottom: 15px;
          line-height: 1.2;
        }

        .bento-desc {
          font-size: 16px;
          line-height: 1.6;
          color: #4b5563;
          margin: 0;
        }

        @media (max-width: 991px) {
          .bento-large, .bento-medium { grid-column: span 12; }
          .bento-card { padding: 50px; }
        }
      `}</style>

      <div className="bento-container">
        {/* Header Section */}
        <div className="text-center mb-4">
          <h2 className="display-5 mb-3" style={{ fontWeight: 800, color: '#111827', letterSpacing: '-0.03em' }}>
    Benefits of Outsourcing  <span style={{ color: '#6c5ce7' }}>Denial Management to AcerHealth</span>
          </h2>
          <p className="para-desc mx-auto mb-0" style={{ maxWidth: '1500px', fontSize: '20px', color: '#6b7280', lineHeight: 1.6 ,}}>
            AcerHealth helps U.S. healthcare practices improve financial performance by delivering structured denial management that 
            goes beyond claim recovery. Our approach focuses on measurable outcomes, operational efficiency, and long-term denial 
            prevention—without adding administrative burden to internal teams.
          </p>
        </div>

        <div className="bento-grid">
          {/* Row 1: Large Left, Medium Right */}
          <div className="bento-card bento-large">
            <div className="image-wrapper">
              <img src={ReducedDenialIcon} alt="Shield and cash icons with downward percentage symbol representing reduced claim denial rates and prevention of revenue leakage for healthcare providers in the USA" />
            </div>
            <div className="text-content">
              <h3 className="bento-title">Reduced Denial Rates and Revenue Leakage</h3>
              <p className="bento-desc">
                Through detailed denial analysis and corrective workflows, AcerHealth helps practices lower avoidable denials and recover
                 revenue that might otherwise be written off. Proactive identification of recurring issues supports sustained denial rate reduction over time.
              </p>
            </div>
          </div>

          <div className="bento-card bento-medium">
            <div className="image-wrapper">
              <img src={CashFlowIcon} alt="Medical billing claim marked paid with cash flow and performance meter illustrating faster reimbursements and improved cash flow for healthcare providers in the USA" />
            </div>
            <div className="text-content">
              <h3 className="bento-title">Faster Reimbursements and Improved Cash Flow</h3>
              <p className="bento-desc">
                Timely corrections, payer-aligned resubmissions, and structured appeals help accelerate reimbursement cycles. 
                This reduces outstanding accounts receivable and improves cash flow predictability for U.S. healthcare practices.
              </p>
            </div>
          </div>

          {/* Row 2: Medium Left, Large Right */}
          <div className="bento-card bento-medium">
            <div className="image-wrapper">
              <img src={VisibilityIcon} alt="Denial management dashboard showing claim denial trends, recovery rates, and revenue analytics for healthcare providers in the USA" />
            </div>
            <div className="text-content">
              <h3 className="bento-title">Clear Visibility Into Denial Performance</h3>
              <p className="bento-desc">
             Practices receive consistent reporting on denial trends, recovery rates, and resolution timelines. 
             This transparency enables informed decision-making while maintaining oversight without managing denial workflows internally.
              </p>
            </div>
          </div>

          <div className="bento-card bento-large">
            <div className="image-wrapper">
              <img src={ComplianceIcon} alt="_   Compliance-focused denial management process with checklist, medical shield, and reports ensuring accurate and regulation-compliant medical billing in the USA" />
            </div>
            <div className="text-content">
            
              <h3 className="bento-title">Compliance-Focused Denial Management</h3>
              <p className="bento-desc">
             AcerHealth aligns denial management activities with U.S. payer rules and HIPAA requirements. 
             Our compliance-driven approach helps reduce audit risk, protect patient data, and ensure billing practices meet regulatory standards.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
          <style>{`
  .cta-section {
    max-width: 1100px;
    margin: 60px auto;
    background: linear-gradient(135deg, #30267a 0%, #a29bfe 100%);
    border-radius: 40px;
    display: flex;
    align-items: center;
    gap: 50px;
    padding: 0; /* Image will be flush with the left side */
    overflow: hidden;
    box-shadow: 0 25px 50px rgba(108, 92, 231, 0.2);
    font-family: 'Inter', sans-serif;
  }

  /* Left Side: Image Container */
  .cta-image {
    flex: 1;
    height: 600px; /* Fixed height to match the content volume */
    position: relative;
  }

  .cta-image img {
    width: 100%;
    height: 120%;
    object-fit: cover; /* Image covers the full area */
    display: block;
  }

  /* Right Side: Content Container */
  .cta-content {
    flex: 1.2;
    padding: 50px 50px 50px 0; /* Padding on top, bottom, and right */
    color: #ffffff;
  }

  .cta-content h2 {
    font-size: 2.2rem;
    font-weight: 850;
    line-height: 1.2;
    margin-bottom: 20px;
    letter-spacing: -1px;
  }

  .cta-content p {
    font-size: 18px;
    line-height: 1.6;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 0.9);
  }

  /* Button Styling */
  .cta-button {
    display: inline-block;
    background: #ffffff;
    color: #6c5ce7;
    padding: 16px 35px;
    border-radius: 15px;
    font-weight: 700;
    text-decoration: none;
    font-size: 16px;
    transition: all 0.3s ease;
    box-shadow: 0 10px 20px rgba(0,0,0,0.1);
  }

  .cta-button:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 30px rgba(0,0,0,0.2);
    background: #fbfbff;
  }

  /* Mobile Responsiveness */
  @media (max-width: 991px) {
    .cta-section {
      flex-direction: column;
      margin: 20px;
      text-align: center;
    }
    .cta-image {
      width: 100%;
      height: 200px;
      flex: none;
    }
    .cta-content {
      padding: 40px 20px;
      flex: none;
    }
  }
`}</style>

    
          <style>{`
  .acer-container {
    max-width: 1100px;
    margin: 50px auto;
    font-family: 'Inter', sans-serif;
    padding: 0 20px;
  }
.cta-section {
  width: 90%;
  max-width: 1400px;               /* wider than acer-container */
  margin: 80px auto;
  padding: clamp(2rem, 5vw, 4rem);

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(2rem, 6vw, 5rem);
  align-items: center;

  background: #1e4c7a;
  border-radius: 32px;
}

  .acer-header {
    text-align: center;
    margin-bottom: 60px;
  }

  .acer-header h2 {
    font-size: 2.5rem;
    font-weight: 900;
    color: #1a1a1a;
    letter-spacing: -1.5px;
  }

  /* The Point-by-Point Row */
  .acer-row {
    display: flex;
    align-items: center;
    gap: 50px;
    margin-bottom: 80px;
    transition: all 0.4s ease;
  }

 .acer-image-box {
    flex: 1;
    height: 350px; 
    border-radius: 30px;
    overflow: hidden;
    border: 1px solid #f0f0f5;
    box-shadow: 0 15px 35px rgba(0,0,0,0.05);
    /* Added background to make 'contain' look seamless */
    background-color: #f9f9fb; 
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px; /* Gives the image some breathing room */
  }

  /* THE KEY FIX: object-fit: contain */
  .acer-image-box img {
    width: 100%;
    height: 100%;
    /* This ensures the FULL image is visible inside the 500px box */
    object-fit: contain; 
    transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  .acer-row:hover .acer-image-box img {
    transform: scale(1.08);
  }

  /* Content on the right */
  .acer-text-box {
    flex: 1.2;
  }

  .acer-text-box h3 {
    font-size: 1.6rem;
    color: #4334b4;
    font-weight: 800;
    margin-bottom: 15px;
    letter-spacing: -0.5px;
  }

  .acer-text-box p {
    font-size: 17px;
    line-height: 1.7;
    color: #636e72;
    margin: 0;
  }

  /* Mobile Layout */
  @media (max-width: 768px) {
    .acer-row {
      flex-direction: column;
      gap: 20px;
      margin-bottom: 50px;
    }
   
  }
`}</style>

          <div className="mx-4 mx-md-4 mx-xl-6">
            <div class="acer-header">
              <h2 className="main-title mb-4" style={{ fontSize: '2.6rem', fontWeight: '800', letterSpacing: '-1.5px' }}>
                Why Choose AcerHealth for   <span className="text-gradient"> Denial Management Services</span>
              </h2>
              <p className="para-desc mx-auto mb-0" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify' }}>
                AcerHealth is a trusted denial management services provider for U.S. healthcare practices seeking reliable revenue recovery, operational consistency,
                and clear accountability. Our denial management model is designed to support ongoing financial performance while aligning closely with U.S.
                payer rules and compliance requirements.
              </p>
            </div>

            <div class="acer-row">
              <div class="acer-image-box">
                <img src={DenialManagement} alt="_   Healthcare professional reviewing claim denials dashboard with U.S. map and analytics, representing expert denial management services in the USA" />
              </div>
              <div class="acer-text-box">
                <h3>Focused Expertise in U.S. Denial Management</h3>
                <p>AcerHealth works exclusively with U.S. healthcare billing and denial workflows. Our teams understand Medicare,
                  Medicaid, and commercial payer denial patterns, allowing us to address denials accurately and within payer-specific guidelines.</p>
              </div>
            </div>

            <div class="acer-row">
              <div class="acer-image-box">
                <img src={Structrd} alt="Healthcare team reviewing denial management workflow dashboard with tasks, appeals, and performance metrics to ensure structured and accountable claims processing" />
              </div>
              <div class="acer-text-box">
                <h3>Structured and Accountable Workflows</h3>
                <p>Denial management at AcerHealth follows defined processes for analysis, correction, appeals, and follow-ups.
                  This structured approach ensures consistency, timely action, and measurable outcomes across all denial categories.</p>
              </div>
            </div>

            <div class="acer-row">
              <div class="acer-image-box">
                <img src={Transprency} alt="Medical billing specialist reviewing denial management reporting dashboard with analytics, recovery rates, and claim trends for transparent healthcare revenue oversight" />
              </div>
              <div class="acer-text-box">
                <h3>Transparency Through Reporting and Oversight</h3>
                <p>Practices receive regular visibility into denial volumes, recovery progress, and resolution timelines.
                  This transparency allows leadership teams to maintain oversight and confidence without managing denial activities internally.</p>
              </div>
            </div>

            <div class="acer-row">
              <div class="acer-image-box">
                <img src={scallable} alt="Healthcare providers reviewing denial management dashboard with growth charts, illustrating scalable medical billing support for expanding practices in the USA" />
              </div>
              <div class="acer-text-box">
                <h3>Scalable Support for Growing Practices</h3>
                <p>AcerHealth’s denial management services are designed to scale with practice needs. Whether managing rising
                  denial volumes or adapting to changing payer requirements, our model provides dependable support as operations evolve.</p>
              </div>
            </div>
          </div>
          <section className="faq-section">
            <div className="faq-background-shapes">
              <div className="shape shape-1"></div>
              <div className="shape shape-2"></div>
            </div>

            <div className="faq-content">
              <h2 className="faq-title" style={{ fontSize: '2.6rem', fontWeight: '800', letterSpacing: '-1.5px' }}>
                Frequently <span className="text-gradient"> Asked Questions</span>
              </h2>

              <div className="faq-list">
                <div className="faq-item">
                  <h3>Who should use denial management services in the USA?</h3>
                  <p>
                    Denial management services are ideal for U.S. healthcare practices experiencing frequent claim denials, delayed reimbursements,
                    or increasing administrative workload. Practices that bill Medicare, Medicaid, and commercial payers benefit most from
                    structured denial resolution and prevention support.
                  </p>
                </div>

                <div className="faq-item">
                  <h3>Does AcerHealth provide denial management services only for U.S. practices?</h3>
                  <p>
                    Yes. AcerHealth’s denial management services are designed exclusively for U.S. healthcare practices and
                    aligned with U.S. payer rules, reimbursement models, and compliance requirements.
                  </p>
                </div>

                <div className="faq-item">
                  <h3>What types of claim denials does AcerHealth manage?</h3>
                  <p>
                    AcerHealth manages eligibility and authorization denials, coding and documentation denials, timely filing
                    issues, and payer-specific policy denials across Medicare, Medicaid, and commercial insurance plans.
                  </p>
                </div>

                <div className="faq-item">
                  <h3>How does outsourcing denial management improve cash flow?</h3>
                  <p>
                    Outsourcing denial management helps improve cash flow by accelerating claim corrections, managing appeals
                    within payer timelines, and preventing repeat denials—reducing write-offs and shortening reimbursement cycles.
                  </p>
                </div>

                <div className="faq-item">
                  <h3>Is denial management with AcerHealth HIPAA compliant?</h3>
                  <p>
                    Yes. AcerHealth follows HIPAA-compliant processes and data security standards to protect
                    patient information while managing denied claims and appeals.
                  </p>
                </div>

                <div className="faq-item">
                  <h3>Will my practice have visibility into denial management performance?</h3>
                  <p>
                    Yes. AcerHealth provides regular reporting on denial volumes, recovery progress, and resolution timelines,
                    allowing practices to maintain visibility and oversight without managing denial workflows internally.
                  </p>
                </div>
              </div>
            </div>

            <style>{`
    /* Base section styling */
    .faq-section {
      position: relative;
      padding-block: clamp(6rem, 12vw, 8rem);
      overflow: hidden;
      background: linear-gradient(135deg, #f0f4ff 0%, #ffffff 100%);
      font-family: 'Inter', sans-serif;
    }

    /* Background shapes for unique style */
    .faq-background-shapes .shape {
      position: absolute;
      border-radius: 50%;
      opacity: 0.2;
      filter: blur(120px);
      z-index: 1;
    }

    .shape-1 {
      width: 400px;
      height: 400px;
      background: #6c5ce7;
      top: -100px;
      left: -100px;
    }

    .shape-2 {
      width: 500px;
      height: 500px;
      background: #00b894;
      bottom: -150px;
      right: -150px;
    }

    /* Content styling */
    .faq-content {
      position: relative;
      z-index: 2;
      display: flex;
      flex-direction: column;
      gap: clamp(2rem, 5vw, 4rem);
      padding-inline: clamp(2rem, 8vw, 6rem);
    }

    .faq-title {
      font-size: clamp(2.5rem, 5vw, 3rem);
      font-weight: 900;
      text-align: center;
      color: #1a1a1a;
    }

    /* FAQ list with alternating layout */
    .faq-list {
      display: flex;
      flex-direction: column;
      gap: clamp(2rem, 4vw, 3rem);
    }

    .faq-item {
      background: rgba(255, 255, 255, 0.85);
      border-left: 6px solid #4334b4;
      padding: clamp(1.5rem, 3vw, 2rem);
      border-radius: 16px;
      backdrop-filter: blur(12px);
      box-shadow: 0 16px 40px rgba(0,0,0,0.05);
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }

    .faq-item:hover {
      transform: translateY(-4px);
      box-shadow: 0 24px 48px rgba(0,0,0,0.08);
    }

    .faq-item h3 {
      font-size: clamp(1.3rem, 2.5vw, 1.6rem);
      font-weight: 700;
      color: #4334b4;
      margin-bottom: 0.75rem;
    }

    .faq-item p {
      font-size: clamp(1rem, 1.5vw, 1.125rem);
      line-height: 1.7;
      color: #555b6e;
      margin: 0;
    }

    /* Alternating layout for larger screens */
    @media (min-width: 768px) {
      .faq-list {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: clamp(2rem, 4vw, 4rem);
      }

      .faq-item:nth-child(odd) {
        border-left-color: #6c5ce7;
      }
      .faq-item:nth-child(even) {
        border-left-color: #00b894;
      }
    }
  `}</style>
          </section>





        </div>
      </div>
      <DownContact DownContactTitle={DownContactTitle} />
    </MDBContainer>
  );
};
export default MedicalbillingDesc;
